import React, { useState, useEffect } from 'react';
import { useToast } from '../../../context/toast';
import { renderIcon } from '../../../utils/icons';
import { Card, Btn } from '../../../components/ui';
import api from '../../../utils/api';

export default function CloudStorageCard({ siteId, isAdmin, theme, isDark }) {
  const { toast } = useToast();
  const [cloudProvider, setCloudProvider] = useState('');
  const [cloudFolderId, setCloudFolderId] = useState('');
  const [cloudSaving, setCloudSaving] = useState(false);
  const [cloudLoaded, setCloudLoaded] = useState(false);

  useEffect(() => {
    if (siteId) {
      setCloudLoaded(false);
      (async () => {
        try {
          const r = await api.get('/api/sites/' + siteId + '/cloud');
          setCloudProvider(r.cloud_provider || '');
          setCloudFolderId(r.cloud_folder_id || '');
          setCloudLoaded(true);
        } catch (e) {
          console.error('Cloud load err:', e.message);
          setCloudLoaded(true);
        }
      })();
    }
  }, [siteId]);

  const saveCloud = async () => {
    setCloudSaving(true);
    try {
      await api.put('/api/sites/' + siteId + '/cloud', { cloud_provider: cloudProvider || null, cloud_folder_id: cloudFolderId || null });
      toast('Cloud storage saved', 'success');
    } catch (e) {
      toast(e.message, 'error');
    } finally {
      setCloudSaving(false);
    }
  };

  if (!isAdmin) return null;

  return (
    <Card style={{ marginBottom: 16, padding: 16 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12 }}>
        {renderIcon('cloud', 18, theme.accent)}
        <span style={{ fontSize: 15, fontWeight: 700, color: theme.text }}>Cloud Storage</span>
        {cloudProvider ? (
          <span style={{ fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 10, background: 'rgba(74,222,128,0.15)', color: '#4ADE80', border: '1px solid rgba(74,222,128,0.3)' }}>● Configured</span>
        ) : (
          <span style={{ fontSize: 11, fontWeight: 600, padding: '2px 8px', borderRadius: 10, background: 'rgba(107,114,128,0.15)', color: '#6b7280', border: '1px solid rgba(107,114,128,0.3)' }}>Not configured</span>
        )}
      </div>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
        <select
          value={cloudProvider}
          onChange={(e) => setCloudProvider(e.target.value)}
          style={{ background: theme.bgCard, color: theme.text, border: '1px solid ' + theme.border, borderRadius: 8, padding: '8px 12px', fontSize: 13, cursor: 'pointer', minWidth: 140 }}
        >
          <option value="">None</option>
          <option value="google_drive">Google Drive</option>
          <option value="dropbox">Dropbox</option>
          <option value="onedrive">OneDrive</option>
        </select>
        <input
          type="text"
          value={cloudFolderId}
          onChange={(e) => setCloudFolderId(e.target.value)}
          placeholder="Folder path or ID"
          style={{ background: theme.bgCard, color: theme.text, border: '1px solid ' + theme.border, borderRadius: 8, padding: '8px 12px', fontSize: 13, flex: 1, minWidth: 180 }}
        />
        <Btn sm primary onClick={saveCloud} dis={cloudSaving}>{cloudSaving ? 'Saving...' : 'Save'}</Btn>
      </div>
    </Card>
  );
}
